import React from 'react'
import { ToggleButton } from 'react-bootstrap'

import { HorizontalStack } from '@ztechapps/webui.util'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import type { OnChangeFilter } from '../../../../config/types'
import { useContext } from '../Context'
import { FilterGroup } from './FilterGroup'

export const Category = () => {
  const { categoryFilter, metadataSchema, onChangeFilter } = useContext()

  const [categories, setCategories] = React.useState([])
  React.useEffect(() => {
    if (metadataSchema) {
      setCategories([...(metadataSchema?.category?.inputProps?.options ?? {})])
    }
  }, [metadataSchema])

  return (
    <FilterGroup filterName="category" title="Category">
      <div>
        <HorizontalStack gap={2} className="flex-wrap">
          {categories?.map((category) => {
            return (
              <CategoryItem
                key={category?.value}
                label={category?.label}
                value={category?.value}
                categoryFilter={categoryFilter}
                onChangeFilter={onChangeFilter}
              />
            )
          })}
        </HorizontalStack>
      </div>
    </FilterGroup>
  )
}

const CategoryItem = ({
  label,
  value,
  categoryFilter,
  onChangeFilter,
}: {
  label: string
  value: string
  categoryFilter: string
  onChangeFilter: OnChangeFilter
}) => {
  const trackEvent = useTrackEvent()
  const { onBoarding } = useContext()

  const onChange = (e) => {
    const isChecked = e?.target?.checked
    if (isChecked) {
      trackEvent('Category filter', { category_label: label, category_value: value })
    }
    onChangeFilter({ categoryFilter: value })
    onBoarding?.goNext()
  }

  const checked = categoryFilter === value

  return (
    <ToggleButton
      id={value}
      type="checkbox"
      variant="outline-primary"
      name="shapes"
      value={value}
      checked={checked}
      onChange={onChange}
    >
      {label}
    </ToggleButton>
  )
}
